import { render, staticRenderFns } from "./GoogleContacts.vue?vue&type=template&id=bb9a2474&"
import script from "./GoogleContacts.vue?vue&type=script&lang=js&"
export * from "./GoogleContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports